import { render } from "./AppLayoutNavbar.vue?vue&type=template&id=2ae9f10c"
import script from "./AppLayoutNavbar.vue?vue&type=script&lang=js"
export * from "./AppLayoutNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__